import { GET_AUP_LIST } from '../../types'
import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'
const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export const getAupList = () => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const response = await trackPromise(window.fetch(`${api}/aups/${accountId}`, options))

    if (!response.status || response.status === 404 || response.status === 401 || response.status === 500) {
      log.warn('non 200 status code from aups')
    } else {
      const { data } = await response.json()
      const mappedData = data.map((dataPiece) => {
        return ({
          ...dataPiece,
          aupHTML: JSON.parse(dataPiece.aupHTML)
        })
      })
      dispatch({
        type: GET_AUP_LIST,
        payload: mappedData
      })
    }
  }
}

export const postNewAup = (aupName, aupHTML, aupText, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const accountID = accountId

    const body = { aupName, aupHTML, aupText, createdBy: supervisorID, updatedBy: supervisorID }

    const options = {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/aups/${accountID}/new`, options))
    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
      // dispatch({
      //   type: POST_AUP,
      //   payload: { ...body }
      // })
    }
  }
}

export const updateAup = (aupID, newAupName, aupSendContent, aupSendText, fireSuccess, fireFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId, supervisorID } = getState().auth

    const accountID = accountId

    const body = { aupName: newAupName, aupHTML: aupSendContent, aupText: aupSendText, updatedBy: supervisorID }

    const options = {
      method: 'PUT',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(body)
    }

    const response = await trackPromise(window.fetch(`${api}/aups/${accountID}/${aupID}`, options))
    if (!response.status || response.status === 500 || response.status === 400 || response.status === 401 || response.status === 404) {
      fireFailure()
    } else {
      fireSuccess()
      // dispatch({
      //   type: UPDATE_AUP,
      //   payload: { ...body }
      // })
    }
  }
}

export const deleteAup = (aupID, fireDeleteSuccess, fireDeleteFailure) => {
  return async function (dispatch, getState) {
    const { token, accountId } = getState().auth

    const options = {
      method: 'DELETE',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    }

    const responseDel = await trackPromise(window.fetch(`${api}/aups/${accountId}/${aupID}`, options))

    if (!responseDel.status || responseDel.status === 401 || responseDel.status === 404 || responseDel.status === 500) {
      fireDeleteFailure()
    } else {
      fireDeleteSuccess()
    }
  }
}
